<template>
    <b-card
        no-body
        class="card-payment"
    >
        <b-card-header>
            <b-card-title>Filtro</b-card-title>
        </b-card-header>
        <b-card-body>
            <b-form>
                <b-row>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Código instalación"
                            label-for="code"
                            class="mb-2"
                        >
                            <b-form-input
                                id="code"
                                v-model="search.installation_code"
                                type="text"
                                autocomplete="off"
                                @keyup="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="1" md="6" sm="6">
                      <b-form-group
                          label="Instalación Activa"
                          label-for="active"
                          class="mb-2"
                      >
                        <select v-model="search.active" class="custom-select" @change="searchMasterInstallation()">
                          <option value=""/>
                          <option v-for="status in boolean"
                                  :key="status.value"
                                  :value="status.value"> {{ status.name }}
                          </option>
                        </select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                      <b-form-group
                          label="Cliente"
                          label-for="client"
                          class="mb-2"
                      >
                        <b-form-input
                            id="code"
                            v-model="search.client"
                            type="text"
                            autocomplete="off"
                            @keyup="searchMasterInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Responsable"
                            label-for="responsible"
                            class="mb-2"
                        >
                            <v-select
                                v-model="search.responsible"
                                class="pt-0" label="name" name="name"
                                :reduce="(option) => option.name"
                                :options="responsiblesList"
                                multiple
                                @input="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                        <b-form-group
                            label="Tipo de Instalación"
                            label-for="typology"
                            class="mb-2"
                        >
                            <v-select
                                v-model="search.typology"
                                class="pt-0" label="name" name="name"
                                :reduce="(option) => option.id"
                                :options="typologiesList"
                                multiple
                                @input="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group label="País" label-for="country">
                        <v-select
                            v-model="search.country"
                            class="pt-0" label="country" name="country"
                            :reduce="(option) => option.country"
                            :options="countriesList"
                            @input="searchMasterInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                        <b-form-group
                            label="Comunidad autónoma"
                            label-for="autonomous_community"
                        >
                            <b-form-input
                                id="autonomous_community"
                                v-model="search.autonomous_community"
                                type="text"
                                autocomplete="off"
                                @keyup="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group label="Provincia" label-for="province">
                        <v-select
                            v-model="search.province"
                            class="pt-0" label="province" name="province"
                            :reduce="(option) => option.province"
                            :options="provincesList"
                            @input="searchMasterInstallation()"
                        >
                          <span slot="no-options">
                              Seleccione un país
                          </span>
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="1" md="6" sm="6">
                      <b-form-group
                          label="Código Postal"
                          label-for="postal_code"
                      >
                        <b-form-input
                            id="postal_code"
                            v-model="search.postal_code"
                            type="text"
                            autocomplete="off"
                            @keyup="searchMasterInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Empresa"
                            label-for="email"
                            class="mb-2"
                        >
                            <v-select
                                v-model="search.companies"
                                class="pt-0" label="name" name="name"
                                :reduce="(option) => option.id"
                                :options="companiesList"
                                multiple
                                @input="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                        <b-form-group
                            label="Expediente Sistema"
                            label-for="proceeding_code"
                        >
                            <b-form-input
                                id="proceeding_code"
                                v-model="search.proceeding_code"
                                type="text"
                                autocomplete="off"
                                @keyup="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BFormGroup, BFormInput, BForm } from 'bootstrap-vue'
import {createHelpers} from "vuex-map-fields"
import {boolean} from "@/constants/constants"
import vSelect from "vue-select"
import flatPickr from "vue-flatpickr-component"

import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'

const {mapFields} = createHelpers({
    getterType: 'masterInstallation/getField',
    mutationType: 'masterInstallation/updateField',
})

export default {
    name: "MasterInstallationsSearchView",
    components: {
        vSelect,
        BCard,
        BCardHeader,
        BCardTitle,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        clickSearch: {
            type: Function,
        }
    },
    data() {
        return {
            clients: [],
            states: [],
            companiesList: [],
            responsiblesList: [],
            countriesList: [],
            provincesList: [],
            typologiesList: [],
            countryId: null,
            SpanishLocale,
            boolean
        }
    },
    computed: {
        ...mapFields({
            search: 'search',
        }),
    },
    watch: {
      "search.country": function (country, oldCountryId) {
        this.$emit('update', { country_id: country })
        if (country) {
          const foundCountry = this.countriesList.find(c => c.country === country)
          this.getAllProvincesCountries(foundCountry.country_id)
        }
      },
    },
    mounted() {
        this.getCompanies()
        this.getResponsibles()
        this.getAllCountries()
        this.getTypologies()
    },
    methods: {
        searchMasterInstallation: function (){
            this.clickSearch()
        },
        getCompanies() {
          this.showLoading = true

          const userCompanies = this.$store.state.AppActiveUser.companies

          if (!userCompanies || userCompanies.length === 0) {
            // Si no hay compañías en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('companies/getAllCompanies')
                .then(response => {
                  this.companiesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo compañías:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay compañias en AppActiveUser, se usan esas
            this.companiesList = userCompanies.map(company => ({
              id: company.id,
              name: company.name
            }))
            this.showLoading = false
          }
        },
        getResponsibles() {
          this.showLoading = true

          const userResponsibles = this.$store.state.AppActiveUser.responsibles

          if (!userResponsibles || userResponsibles.length === 0) {
            // Si no hay responsables en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('responsibles/getAllResponsibles')
                .then(response => {
                  this.responsiblesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo responsables:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay responsables en AppActiveUser, se usan esas
            this.responsiblesList = userResponsibles.map(responsible => ({
              id: responsible.id,
              name: responsible.name
            }))
            this.showLoading = false
          }
        },
        getAllCountries() {
          this.showLoading = true

          this.$store.dispatch('provincesCountries/getAllCountries')
              .then(response => {
                this.countriesList = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
        getAllProvincesCountries(countryId) {
          this.showLoading = true
          this.$store.dispatch('provincesCountries/getAllProvincesByCountry',{
            countryId: countryId,
          })
              .then(response => {
                this.provincesList = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },

        getTypologies() {
          this.showLoading = true

          const userTypologies = this.$store.state.AppActiveUser.typologies

          if (!userTypologies || userTypologies.length === 0) {
            // Si no hay tipologias en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('typologies/listTypologies')
                .then(response => {
                  this.typologiesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo tipologias:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay tipologias en AppActiveUser, se usan esas
            this.typologiesList = userTypologies.map(typology => ({
              id: typology.id,
              name: typology.name
            }))
            this.showLoading = false
          }
        },
    }
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>